import basketStore from '@shared/store/basket'
import useContract from '@shared/hooks/useContract'
import usePerson from '@shared/hooks/usePerson'
import useProduct from '@shared/hooks/useProduct'

import { BASKET_OFFER_EDIT_SCOPE, PRODUCT_STATE } from '@shared/config/constants'
import { isRequired } from '@shared/utils/CustomErrors'

export default function useProductState() {
  // HOOKS
  const { getContractPerson, getContractProduct, getSelectedProductsOfContractPerson } = useContract()
  const { getPersonByPartnerNumber } = usePerson()
  const { getReplaceableProducts, getSelectedProductsOfPerson } = useProduct()

  // METHODS
  function state(partnerNumber, productId = isRequired('productId')) {
    if (basketStore.basket.basketOfferEditScope !== BASKET_OFFER_EDIT_SCOPE.ALL) return PRODUCT_STATE.READONLY
    if (!partnerNumber) return PRODUCT_STATE.EDITABLE

    const person = getPersonByPartnerNumber(partnerNumber)
    const basketProduct = getSelectedProductsOfPerson(person.products.products).find(p => p.productId === productId)

    // Channel switch with newly added person, therefore existing customer not in contract-persons array
    const contractPerson = getContractPerson(partnerNumber)
    if (!contractPerson) return PRODUCT_STATE.EDITABLE

    const contractProducts = getSelectedProductsOfContractPerson(partnerNumber)
    const contractProductById = contractProducts.find(p => p.productId === productId)

    const isProductWithinGroupAlreadySelected = () => {
      if (contractProductById && contractProductById.selected) return true

      const replaceableProducts = getReplaceableProducts(productId)
      return replaceableProducts.find(__productId => getContractProduct(partnerNumber, __productId)?.selected)
    }

    if (basketProduct?.selected && !isProductWithinGroupAlreadySelected()) {
      return PRODUCT_STATE.EDITABLE
    }

    // TODO: is second condition necessary?
    if (basketProduct?.selected && isProductWithinGroupAlreadySelected()) {
      if (basketProduct.price.duration && basketProduct.price.duration !== '1') {
        return PRODUCT_STATE.READONLY
      } else {
        return PRODUCT_STATE.NOT_DELETABLE
      }
    }
    return PRODUCT_STATE.EDITABLE
  }

  // Expose
  return {
    // fn
    state,
  }
}
